import Hero from "../Hero/Hero";
import Tile from "../Tile/Tile";
export default function Home() {
  return (
    <div className="bg-white">
      <Hero />
      <Tile />
    </div>
  );
}
